document.addEventListener("DOMContentLoaded", function () {
  function removePoweredBy() {
    document
      .querySelectorAll(".lgw-w-full.lgw-text-xs.lgw-mt-2")
      .forEach((el) => el.remove());
  }

  removePoweredBy();

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.matches(".lgw-w-full.lgw-text-xs.lgw-mt-2")) {
            node.remove();
          } else if (node.querySelectorAll) {
            node
              .querySelectorAll(".lgw-w-full.lgw-text-xs.lgw-mt-2")
              .forEach((el) => el.remove());
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => {
    observer.disconnect();
  }, 10000);
});
